module.exports = __webpack_public_path__ + "img/tzalachat_yes.5bd0011c.png";